/**
 * Image Accordion Block - Frontend JavaScript
 * Handles click-to-toggle behavior at mobile and lazy loading of background images
 */

(function () {
	const mobileBreakpoint = 768;
	const isMobile = () => window.innerWidth < mobileBreakpoint;

	/**
	 * Lazy load background images using Intersection Observer
	 */
	function initLazyBackgrounds() {
		const lazyPanels = document.querySelectorAll('.commcore26-image-accordion__panel[data-bg]');

		if (!lazyPanels.length) return;

		// Use Intersection Observer if available
		if ('IntersectionObserver' in window) {
			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							const panel = entry.target;
							const bgUrl = panel.dataset.bg;
							if (bgUrl) {
								panel.style.backgroundImage = `url(${bgUrl})`;
								panel.removeAttribute('data-bg');
							}
							observer.unobserve(panel);
						}
					});
				},
				{
					rootMargin: '200px 0px', // Start loading 200px before entering viewport
					threshold: 0,
				}
			);

			lazyPanels.forEach((panel) => observer.observe(panel));
		} else {
			// Fallback: load all images immediately
			lazyPanels.forEach((panel) => {
				const bgUrl = panel.dataset.bg;
				if (bgUrl) {
					panel.style.backgroundImage = `url(${bgUrl})`;
					panel.removeAttribute('data-bg');
				}
			});
		}
	}

	function initImageAccordion() {
		const accordions = document.querySelectorAll('.commcore26-image-accordion');

		// Initialize lazy loading for background images
		initLazyBackgrounds();

		accordions.forEach((accordion) => {
			// Skip if already initialized
			if (accordion.dataset.initialized) return;
			accordion.dataset.initialized = 'true';

			const panels = accordion.querySelectorAll('.commcore26-image-accordion__panel');

			panels.forEach((panel) => {
				panel.addEventListener('click', (e) => {
					if (!isMobile()) return;

					// Don't toggle if clicking on the CTA link
					if (e.target.closest('.commcore26-image-accordion__cta')) {
						return;
					}

					e.preventDefault();

					// Toggle active state
					if (panel.classList.contains('is-active')) {
						panel.classList.remove('is-active');
					} else {
						panel.classList.add('is-active');
					}
				});

				// Handle keyboard interaction
				panel.addEventListener('keydown', (e) => {
					if (!isMobile()) return;

					if (e.key === 'Enter' || e.key === ' ') {
						// Don't toggle if focus is on the CTA
						if (e.target.closest('.commcore26-image-accordion__cta')) {
							return;
						}

						e.preventDefault();
						panel.classList.toggle('is-active');
					}
				});
			});
		});
	}

	// Initialize when DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initImageAccordion);
	} else {
		// DOM already loaded, run immediately
		initImageAccordion();
	}
})();
